import robotoRegular from './Roboto-Regular';
import robotoBold from './Roboto-Bold';
import robotoLight from './Roboto-Light';
import robotoItalic from './Roboto-Italic';
import robotoBoldItalic from './Roboto-BoldItalic';

export default {
    Roboto: {
        normal: {
            ttf: 'Roboto-Regular.ttf',
            base64: robotoRegular
        },
        bold: {
            ttf: 'Roboto-Bold.ttf',
            base64: robotoBold
        },
        lighter: {
            ttf: 'Roboto-Light.ttf',
            base64: robotoLight
        },
        italic: {
            ttf: 'Roboto-Italic.ttf',
            base64: robotoItalic
        },
        bolditalic: {
            ttf: 'Roboto-BoldItalic.ttf',
            base64: robotoBoldItalic
        }
    }
};
